import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { FaTimes, FaExclamationCircle, FaCheckCircle } from 'react-icons/fa';
import { unmatchUser } from '../../Services/User/Chat';
import { showToast } from '../Toast/Toast';
import CustomButton from '../CustomButton';
import './UnmatchUserModal.css';

const UnmatchUserModal = ({ show, onHide, userName, userId }) => {
  const [step, setStep] = useState(1); // 1: Confirmation, 2: Success
  const [unmatching, setUnmatching] = useState(false);

  const handleConfirm = async () => {
    try {
      setUnmatching(true);
      const response = await unmatchUser(userId);
      
      if (response.status) {
        setStep(2);
      } else {
        showToast(response.message || 'Failed to unmatch user', 'error');
      }
    } catch (error) {
      console.error('Error unmatching user:', error);
      showToast(error.message || 'Failed to unmatch user', 'error');
    } finally {
      setUnmatching(false);
    }
  };

  const handleCancel = () => {
    setStep(1);
    onHide();
  };

  const handleSuccessClose = () => {
    setStep(1);
    onHide();
  };

  const renderConfirmationStep = () => (
    <div className="unmatch-modal-content">
      <div className="unmatch-icon-wrapper">
        <FaExclamationCircle className="unmatch-icon" />
      </div>
      <h4 className="unmatch-modal-title">Un match</h4>
      <p className="unmatch-modal-question">
        Are you sure you want to unmatch <strong>{userName || 'this user'}</strong>?
      </p>
      <div className="unmatch-modal-buttons">
        <CustomButton
          onClick={handleConfirm}
          disabled={unmatching}
          className="unmatch-yes-btn"
        >
          {unmatching ? 'Unmatching...' : 'Yes'}
        </CustomButton>
        <CustomButton
          onClick={handleCancel}
          variant="secondary"
          className="secondaryButton"
        >
          No
        </CustomButton>
      </div>
    </div>
  );

  const renderSuccessStep = () => (
    <div className="unmatch-modal-content">
      <div className="success-icon-wrapper">
        <FaCheckCircle className="success-icon" />
      </div>
      <h4 className="unmatch-modal-title">Successful</h4>
      <p className="success-message">
        {userName || 'The user'} has been unmatched successfully!
      </p>
      <div className="unmatch-form-buttons">
        <CustomButton
          onClick={handleSuccessClose}
          className="unmatch-ok-btn"
        >
          Ok
        </CustomButton>
      </div>
    </div>
  );

  return (
    <Modal show={show} onHide={handleCancel} centered className="unmatch-user-modal">
      <Modal.Body className="unmatch-modal-body">
        <button className="modal-close-btn" onClick={handleCancel}>
          <FaTimes />
        </button>
        
        {step === 1 && renderConfirmationStep()}
        {step === 2 && renderSuccessStep()}
      </Modal.Body>
    </Modal>
  );
};

export default UnmatchUserModal;

